import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"
import { DateFilter } from "@/types/filters"

export interface ShiftPreference {
  name: string
  value: number
}

export interface WeekdayPreference {
  name: string
  value: number
}

export interface VanOwnership {
  name: string
  value: number
}

export interface AgeDistribution {
  name: string
  value: number
}

export interface DriverPreferencesData {
  shiftPreferencesData: ShiftPreference[]
  weekdayPreferencesData: WeekdayPreference[]
  vanOwnershipData: VanOwnership[]
  ageDistributionData: AgeDistribution[]
  totalApplicants: number
}

interface DriverPreferencesResponse {
  success: boolean
  data: DriverPreferencesData
}

/**
 * Hook to fetch driver preferences data from Supabase Edge Function
 * @param dateFilter - The date filter to apply with startDate and endDate
 */
export const useDriverPreferencesData = (dateFilter: DateFilter = {}, jobId?: string) => {
  return useQuery({
    queryKey: ["driverPreferencesData", dateFilter, jobId ?? "all"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("metrics-driver-preferences", {
        body: {
          startDate: dateFilter.startDate,
          endDate: dateFilter.endDate,
          jobId: jobId ?? null,
        },
      })

      if (error) {
        throw new Error(`Error fetching driver preferences data: ${error.message}`)
      }

      if (!data || !data.success) {
        throw new Error("Failed to fetch driver preferences data")
      }

      const response = data as DriverPreferencesResponse
      return response.data
    },
  })
}
